<template>
  <page-base>
    <router-view></router-view>
  </page-base>
</template>

<script>
import PageBase from "@/modules/Celulares/Core/Components/PageBase";

export default {
  name: "ConfigView",
  components: {PageBase}
}
</script>

<style scoped lang="stylus">
</style>
